export default __webpack_public_path__ + "static/media/db-icon.db4a68a4.svg";